import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import { allocationService } from '../services/allocationService';
import type { Allocation, AllocationBody } from '../types/Allocation';

export type SaveAllocationVariables = { id?: number; body: AllocationBody };

/** `POST /allocations` (nova) ou `PATCH /allocations/:id` (editar) — mesmo diálogo, mesmo hook. */
export function useSaveAllocation() {
  const qc = useQueryClient();
  return useMutation<Allocation, unknown, SaveAllocationVariables>({
    mutationFn: ({ id, body }) =>
      id ? allocationService.update(id, body) : allocationService.create(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: allocationQueries.lists() });
      qc.invalidateQueries({ queryKey: allocationQueries.timelines() });
      qc.invalidateQueries({ queryKey: allocationQueries.checks() });
    },
  });
}
